import gbAntSelectNoLimitCascader from "./src/gb-ant-select-no-limit-cascader.vue";
const gbAntSelectNoLimitCascaderCompenet = function(Vue) {
  Vue.component(gbAntSelectNoLimitCascader.name, gbAntSelectNoLimitCascader);
};
export default gbAntSelectNoLimitCascaderCompenet;
